import type { TMigrationKey } from './types';
import { MIGRATION_KEY_SPLIT } from './types';

export function findShortestMigrationPath(p: {
  startKey: string;
  targetKey: string;
  migrationKeys: TMigrationKey[];
}): TMigrationKey[] {
  const graph: Record<string, TMigrationKey[]> = {};
  const versionKeys = new Set<string>();

  for (const migrationKey of p.migrationKeys) {
    const [sourceKey, destKey] = migrationKey.split(MIGRATION_KEY_SPLIT);
    versionKeys.add(sourceKey);
    versionKeys.add(destKey);

    if (!graph[sourceKey]) {
      graph[sourceKey] = [];
    }

    graph[sourceKey].push(migrationKey);
  }

  // If start or target not in graph, no path exists
  if (!versionKeys.has(p.startKey) || !versionKeys.has(p.targetKey)) {
    return [];
  }

  // BFS to find shortest path
  const queue: Array<{
    key: string;
    path: TMigrationKey[];
  }> = [{
    key: p.startKey,
    path: [],
  }];

  const visited = new Set<string>([p.startKey]);

  while (queue.length > 0) {
    const { key, path } = queue.shift()!;

    if (key === p.targetKey) {
      return path;
    }

    const neighbors = graph[key] || [];

    for (const migrationKey of neighbors) {
      const [, nextKey] = migrationKey.split('__');

      if (!visited.has(nextKey)) {
        visited.add(nextKey);
        queue.push({
          key: nextKey,
          path: [...path, migrationKey],
        });
      }
    }
  }

  return [];
}
